import React from 'react'
import './CreateThreatsForm.scss'

import { Grid, Typography, InputLabel } from '@material-ui/core'
import { FieldArray } from 'formik'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'

import { InputField, SelectField, MultipleSelectField } from '../../FormFields'
import { selector_entity_types, selector_alliance_types } from '../../../../config/constant'

interface ThreatsArrayHelpers {
    push: any
    remove: any
    form: any
}

interface WaypointsProps {
    threatIndex: number
    threatsArrayHelpers: ThreatsArrayHelpers
}

const Waypoints = ({ threatIndex, threatsArrayHelpers }: WaypointsProps) => {
    const { push, remove, form } = threatsArrayHelpers
    const { values } = form
    const { threats } = values

    return (
        <>
            <Typography variant="subtitle2" gutterBottom>
                Waypoints
            </Typography>
            {threats[threatIndex].waypoints.map((_waypoint: any, index_waypoint: number) => (
                <div key={index_waypoint}>
                    <br />
                    <Typography variant="subtitle2" gutterBottom>
                        Waypoint {index_waypoint + 1}
                    </Typography>
                    <Grid container spacing={3}>
                        <Grid item xs={6} sm={6}>
                            <InputLabel shrink>Latitude</InputLabel>
                            <InputField name={`threats[${threatIndex}].waypoints[${index_waypoint}].lat`} fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <InputLabel shrink>Longitude</InputLabel>
                            <InputField name={`threats[${threatIndex}].waypoints[${index_waypoint}].lon`} fullWidth />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={6} sm={6}>
                            <InputLabel shrink>Altitude (m)</InputLabel>
                            <InputField name={`threats[${threatIndex}].waypoints[${index_waypoint}].alt`} fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <InputLabel shrink>Velocity (m/s)</InputLabel>
                            <InputField name={`threats[${threatIndex}].waypoints[${index_waypoint}].vel`} fullWidth />
                        </Grid>
                    </Grid>
                    {index_waypoint > 0 && (
                        <button
                            className="btn outline red RemoveButton"
                            onClick={() => remove(index_waypoint)}
                            data-test-id="usecase-create_threats_form_remove_waypoint"
                        >
                            Remove waypoint
                        </button>
                    )}
                </div>
            ))}
            <br />
            <span className="AddButton" onClick={() => push({ lat: '', lon: '', alt: '', vel: '' })}>
                <AddCircleOutlineIcon />
                Add a New waypoint
            </span>
        </>
    )
}

interface CreateThreatsFormProps {
    environmentData: any
    formField: any
}

function CreateThreatsForm(props: CreateThreatsFormProps) {
    const environments_names = props.environmentData

    const defaultValues = {
        name: '',
        type: '',
        model: '',
        initial_position: { lat: '', lon: '', alt: '' },
        waypoints: [{ lat: '', lon: '', alt: '', vel: '' }],
        actions_goto: [],
        actions_get_telemetry: [],
        sparq_id: '',
        squad_id: '',
    }

    return (
        <div className="CreateThreatsForm" data-test-id="usecase-create_threats_form">
            <React.Fragment>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <div>
                            <FieldArray name="threats">
                                {(fieldArrayProps) => {
                                    const { push, remove, form } = fieldArrayProps
                                    const { values } = form
                                    const { threats } = values
                                    return (
                                        <div>
                                            <Typography variant="h6" gutterBottom>
                                                Threat items
                                            </Typography>
                                            {threats.map((_threat: any, index: number) => (
                                                <div key={index}>
                                                    <Typography variant="subtitle1" gutterBottom>
                                                        Threat {index + 1}
                                                    </Typography>
                                                    <InputLabel shrink>
                                                        Threat Name <span className="RequiredRed">*</span>
                                                    </InputLabel>
                                                    <InputField type="text" name={`threats[${index}].name`} fullWidth />
                                                    <br />
                                                    <br />
                                                    <InputLabel shrink>
                                                        Threat Type <span className="RequiredRed">*</span>
                                                    </InputLabel>
                                                    <SelectField
                                                        name={`threats[${index}].type`}
                                                        data={selector_entity_types}
                                                        className="th_type_select"
                                                        fullWidth
                                                    />
                                                    <br />
                                                    <br />
                                                    <InputLabel shrink>
                                                        Threat Model <span className="RequiredRed">*</span>
                                                    </InputLabel>
                                                    <InputField type="text" name={`threats[${index}].model`} fullWidth />
                                                    <br />
                                                    <br />
                                                    <Typography variant="subtitle2" gutterBottom>
                                                        Action Environments
                                                    </Typography>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12} sm={12}>
                                                            <InputLabel shrink>Go To</InputLabel>
                                                            <MultipleSelectField
                                                                name={`threats[${index}].actions_goto`}
                                                                data={environments_names}
                                                                className="threats_actions_goto_select"
                                                                fullWidth
                                                                multiple
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={12}>
                                                            <InputLabel shrink>Get Telemetry</InputLabel>
                                                            <MultipleSelectField
                                                                name={`threats[${index}].actions_get_telemetry`}
                                                                data={environments_names}
                                                                className="threats_actions_get_telemetry_select"
                                                                fullWidth
                                                                multiple
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <br />
                                                    <Typography variant="subtitle2" gutterBottom>
                                                        Initial Position
                                                    </Typography>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={6} sm={6}>
                                                            <InputLabel shrink>
                                                                Latitude <span className="RequiredRed">*</span>
                                                            </InputLabel>
                                                            <InputField name={`threats[${index}].initial_position.lat`} fullWidth />
                                                        </Grid>
                                                        <Grid item xs={6} sm={6}>
                                                            <InputLabel shrink>
                                                                Longitude <span className="RequiredRed">*</span>
                                                            </InputLabel>
                                                            <InputField name={`threats[${index}].initial_position.lon`} fullWidth />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={6} sm={6}>
                                                            <InputLabel shrink>
                                                                Altitude (m)<span className="RequiredRed">*</span>
                                                            </InputLabel>
                                                            <InputField name={`threats[${index}].initial_position.alt`} fullWidth />
                                                        </Grid>
                                                    </Grid>
                                                    <br />
                                                    <FieldArray name={`threats[${index}].waypoints`}>
                                                        {(fieldArrayWaypointProps) => (
                                                            <>
                                                                <Waypoints
                                                                    threatIndex={index}
                                                                    threatsArrayHelpers={fieldArrayWaypointProps}
                                                                />
                                                            </>
                                                        )}
                                                    </FieldArray>
                                                    <br />
                                                    <br />
                                                    <InputLabel shrink>SPARQ </InputLabel>
                                                    <InputField type="text" name={`threats[${index}].sparq_id`} fullWidth />
                                                    <br />
                                                    <br />
                                                    <InputLabel shrink>Squad ID</InputLabel>
                                                    <InputField type="text" name={`threats[${index}].squad_id`} fullWidth />
                                                    <br />
                                                    <br />
                                                    <InputLabel shrink>
                                                        Alliance <span className="RequiredRed">*</span>
                                                    </InputLabel>
                                                    <SelectField
                                                        name={`threats[${index}].alliance`}
                                                        data={selector_alliance_types}
                                                        className="th_alliance_select"
                                                        fullWidth
                                                    />
                                                    <br />
                                                    <br />
                                                    {index > 0 && (
                                                        <button
                                                            className="btn outline red RemoveButton"
                                                            onClick={() => remove(index)}
                                                            data-test-id="usecase-create_threats_form_remove_thread"
                                                        >
                                                            Remove Threat {threats[index].name}
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                            <span className="AddButton" onClick={() => push(defaultValues)}>
                                                <AddCircleOutlineIcon />
                                                Add A Thread
                                            </span>
                                        </div>
                                    )
                                }}
                            </FieldArray>
                        </div>
                    </Grid>
                </Grid>
            </React.Fragment>
        </div>
    )
}

export default CreateThreatsForm
